/**
 * Google Ads landing: centred slick testimonials slider.
 * Slick is enqueued by template-google-ads.php.
 */
jQuery(function ($) {
    var $slider = $('.ads-testimonials-slick');
    if (!$slider.length || !$.fn.slick) return;

    $slider.on('init reInit beforeChange', function (event, slick, currentSlide, nextSlide) {
        var centerIndex = (nextSlide !== undefined) ? nextSlide : (currentSlide || 0);

        $slider.find('.slick-slide').removeClass('slick-prev-slide slick-next-slide');
        $slider.find('.slick-slide[data-slick-index="' + (centerIndex - 1) + '"]').addClass('slick-prev-slide');
        $slider.find('.slick-slide[data-slick-index="' + (centerIndex + 1) + '"]').addClass('slick-next-slide');
    });

    $slider.slick({
        centerMode: true,
        variableWidth: true,
        slidesToShow: 3,
        infinite: true,
        prevArrow: '<button type="button" class="slick-prev"></button>',
        nextArrow: '<button type="button" class="slick-next"></button>',
        responsive: [
            {
                breakpoint: 992,
                settings: { centerMode: true, variableWidth: false, slidesToShow: 1 }
            }
        ]
    });
});
